import * as types from "./actionTypes";
import JsonApi from "../api/jsonApi";
import {setBathroomVisualizerPresets} from "./actionFunctions";
import {loaderDisable} from "../bvcomponents/ui/loaderView";

export const setStaticCanvasImage = (staticCanvasImage) => ({
  type: types.SET_STATIC_CANVAS_IMAGE,
  payload: {staticCanvasImage}
});


export const getBvPresets = (room, forVisualizer, withLoader = false) => {
  return async (dispatch, getState) => {
    const {allVisualizersPresets, requestedVisualizerPresets} = getState().bathroomVisualizerState;
    if (allVisualizersPresets[forVisualizer] || requestedVisualizerPresets.includes(forVisualizer)) {
      return;
    }
    dispatch({
      type: types.REQUEST_BV_PRESETS,
      payload: forVisualizer
    });
    return JsonApi.getDisplayRoom(room)
      .then(responseData => {
        // console.log('getBvPresets:', responseData);
        if (!responseData.data || responseData.data.error) {
          dispatch(setBathroomVisualizerPresets([]));
          console.error("get bvPresets error: No response data received");
          return [];
        } else {
          const bvPresets = JSON.parse(responseData.data);
          console.log("bvPresets", room, forVisualizer, bvPresets);
          dispatch(setBathroomVisualizerPresets(bvPresets, forVisualizer));
          return bvPresets
        }
      })
      .catch((error) => {
        if (withLoader) {
          loaderDisable();
        }
        console.log('getDisplayRoom', error);
      });
  }
};
